<template>
    <div>

        <np-application-breadcrumb :mode="'arrowcrumb'" :crumbs="tabsToRender"></np-application-breadcrumb>
        <div class="row">
            <div class="col-12">
                <router-view></router-view>
                <np-pdf-modal v-if="isPublicUser" url="/login/viewcookiedocument/" :title="lang('cookie_policy')"
                              id="elavon-cookie-policy"></np-pdf-modal>
            </div>

        </div>
    </div>
</template>

<script>
    import NPAppBreadcrumb from '../../components/np-application-breadcrumb.vue'
    import * as types from "../../stores/constants";
    import {mapActions} from "pinia";
    import applicationMixin from '../../utils/application-mixin';
    import {NPPdfModal, NPSkeleton} from "netpify/components";
    import useApplicationStore from "../../stores/application_module";

    //TODO the initial commit should happen in the application index page so view/edit/add can access it.
    export default {
        name: "ApplicationAdd",
        mixins: [applicationMixin],
        components: {
            'np-application-breadcrumb': NPAppBreadcrumb,
            'np-skeleton': NPSkeleton,
            'np-pdf-modal': NPPdfModal
        },
        data() {
            return {
                application: [],
                opportunityStatuses: {
                    NEW: '1',
                    PENDING_WITH_MERCHANT: '4'
                },
                tabs: [
                    {
                        display: true,
                        is_active: true,
                        is_open: false,
                        is_complete: false,
                        is_quote_tab: true,
                        short_label: "business_info",
                        label: "tab_business_info_equipment_pricing",
                        lang_key: "tab_business_info_equipment_pricing",
                        tab_id: "tab_business_information",
                        url: "business/",
                    },
                    {
                        display: true,
                        is_active: true,
                        is_open: false,
                        is_complete: false,
                        is_application_tab: true,
                        short_label: "business_details",
                        label: "tab_business_trading_details",
                        lang_key: "tab_business_trading_details",
                        tab_id: "tab_business_details",
                        url: "business_details/",
                    },
                    // {
                    //     display: true,
                    //     is_active: true,
                    //     is_open: false,
                    //     is_complete: false,
                    //     short_label: "equipments",
                    //     label: "tab_equipment_pricing",
                    //     lang_key: "tab_equipment_pricing",
                    //     tab_id: "tab_equipment_pricing",
                    //     url: "products/",
                    // },
                    // {
                    //     display: true,
                    //     is_active: true,
                    //     is_open: false,
                    //     is_complete: false,
                    //     short_label: "tab_bank",
                    //     label: "tab_bank_details_and_signature",
                    //     lang_key: "tab_bank_details_and_signature",
                    //     tab_id: "tab_bank_details",
                    //     url: "bank_details/",
                    // },
                    // {
                    //     display: true,
                    //     is_active: true,
                    //     is_open: false,
                    //     is_complete: false,
                    //     short_label: "tab_outlets",
                    //     label: "tab_outlets",
                    //     lang_key: "tab_outlets",
                    //     tab_id: "tab_outlets",
                    //     url: "outlets/",
                    // },
                    {
                        display: true,
                        is_active: true,
                        is_open: false,
                        is_complete: false,
                        is_application_tab: true,
                        short_label: "tab_documents",
                        label: "tab_supporting_documents_upload",
                        lang_key: "tab_supporting_documents_upload",
                        tab_id: "tab_documents",
                        url: "documents/",
                    },
                    {
                        display: true,
                        is_active: true,
                        is_open: false,
                        is_complete: false,
                        is_application_tab: true,
                        short_label: "review_signature",
                        label: "tab_review_signature",
                        lang_key: "tab_review_signature",
                        tab_id: "tab_review_signature",
                        url: "review/",
                    },
                ],
            }
        },
        created() {
            this[types.FETCH_APPLICATION_PARAMETERS]().then(obj => {
                this.fetchQuoteData();
            }).then(obj => {
                this.fetchApplicationData();
            });
        },
        mounted() {
            // this.setQuoteLock();
        },
        computed: {
            outlets: function (){
                return this.merchant_relation.outlets
            },
            quote_status_id: function () {
                let status_id = '';
                if (this.merchant_user_access.hasOwnProperty('quote')){
                    if (this.merchant_user_access.quote.length > 1) {
                        //TODO if we have more than one quote, we need to know what to do
                    } else {
                        status_id = this.merchant_user_access.quote[0].status_id;
                    }
                }
                return status_id
            },
            tabsToRender: function () {
                let vm = this, tabs = this.jsonCopy(this.tabs);
                tabs.forEach((obj, index) => {
                    //use outlet_ref or index+1 as :outlet_ref for path


                    //we don't use add route except for /business step 1
                    if (obj.is_quote_tab){
                        obj.is_active = true
                    }else{
                        obj.is_active = false
                    }

                    //if quote is not converted, disable application pages (Step 2-4)
                    // if (obj.is_application_tab && !vm.isConvertedQuote) {
                    // }

                    //if application is submitted, disabled steps 1-3 and mark them as complete.
                    //quote has been converted and application created
                    if (vm.isConvertedQuote) {
                        //if quote is converted, set step one to is_complete.
                        if (obj.is_quote_tab) {
                            obj.is_complete = true;
                        }
                        if ((obj.is_application_tab && !this.isOpenApplication)) {
                            obj.is_complete = true;
                            // obj.is_active = false; //TODO we need to rethink what it will act like when it's completed.
                        }
                    }

                    obj.url = this.application_root_path + obj.url;
                });

                return tabs;
            },
        },
        methods: {
            ...mapActions(useApplicationStore, [types.FETCH_APPLICATION_PARAMETERS,

                types.FETCH_QUOTE_DATA,
                types.FETCH_APPLICATION_DATA]),

            ...mapActions(useApplicationStore, [
                types.SET_MERCHANT_HIERARCHY_DATA, types.SET_MERCHANT_DATA, types.SET_MERCHANT_RELATION_DATA,
                types.SET_LOGGED_IN_USER,
                types.SET_APPLICATION_PARAMETERS,
                types.SET_PAGE_CONFIG,
                types.COMMIT_QUOTE,
                types.SET_OUTLETS,
                types.SET_QUOTE_DATA,
                types.SET_APPLICATION_SUBSTATUSES,
                types.SET_QUOTE_LOCK,
                types.SET_MERCHANT_HIERARCHY_CONFIGURATION_TEMPLATES,
                types.SET_MERCHANT_USER_DATA, types.COMMIT_APPLICATION_TABS]),
            // setQuoteLock: function (){
            //     this[types.SET_QUOTE_LOCK](this.quote_status_id == '4')
            // },
            fetchQuoteData: function () {
                let quote_external_id = '', vm = this;

                if (this.isPublicUser) {
                    let opportunity = vue_data.hasOwnProperty('opportunity') ? vue_data.opportunity : {};
                    let quote_block = {};

                    if (this.objectIsNotEmpty(opportunity)) {
                        quote_block = this.opportunityQuoteMap(opportunity);
                    }

                    this[types.COMMIT_QUOTE]({quote: quote_block})
                } else {
                    if (this.objectIsNotEmpty(this.merchant_user_access) && this.merchant_user_access.hasOwnProperty('quote')) {
                        // if (this.merchant_user_access.quote.length > 1) {
                        // TODO if we have more than one quote, we need to know what to do
                        // } else {
                        quote_external_id = this.merchant_user_access.quote[0].quote_external_id;
                        // }
                        //

                        //redirect to the quote edit route
                        location.href = `/quote/edit/${quote_external_id}/business`;

                        let payload = {
                            'user_external_id': this.user.user_external_id,
                            'quote_external_id': quote_external_id,
                        }

                        //fetch and commit Quote Data
                        this[types.FETCH_QUOTE_DATA](payload);

                        // this.setQuoteRootPath(quote_external_id, 'edit')
                    } else {
                        //user has no quote. So pick an unused opportunity_id and for creating the new quote
                        if (this.objectIsNotEmpty(this.merchant_user_access) &&
                            this.merchant_user_access.hasOwnProperty('opportunity')) {
                            //
                            let opportunity = this.merchant_user_access.opportunity.find(obj => {
                                return obj.hasOwnProperty('opportunity_status_id')
                                    && obj.opportunity_status_id == vm.opportunityStatuses.PENDING_WITH_MERCHANT;
                            })

                            if (!!opportunity) {
                                let quote_block = this.opportunityQuoteMap(opportunity);
                                this[types.COMMIT_QUOTE]({quote: quote_block})
                            } else {
                                this.notifyError(this.lang('error_no_available_opportunity'), this.lang('merchant_has_no_opportunity_cant_create_quote'))
                            }
                        } else if (this.isSignerUser) {
                            this.notifyError(this.lang('error'), this.lang('signatory_cannot_perform_this_action'));
                            location.href = '/';
                        } else {
                            this.notifyError(this.lang('error_no_available_opportunity'), this.lang('merchant_has_no_opportunity_cant_create_quote'))
                        }
                    }
                }

            },
            opportunityQuoteMap: function (opportunity){
                const dataMap = {
                    //quote_fields: opportunity_fields
                    opportunity_external_id: 'opportunity_external_id',
                    annual_turnover: 'business_turnover',
                    avg_tran_value: 'business_average_transaction_value',
                    annual_card_turnover: 'business_card_turnover',
                    monthly_card_turnover: 'monthly_card_turnover',
                    legal_name: 'business_legal_name',
                    trade_name: 'business_trade_name',
                    ownership_entity_type: 'business_type',
                    email_address: 'contact_email',
                    contact_first_name: 'contact_first_name',
                    contact_last_name: 'contact_last_name',
                    ent_telephone_code: 'contact_phone_code',
                    telephone_number: 'contact_phone_no',
                    mcc_iso: 'business_mcc',
                };
                const addressMap = {
                    zip_code : 'registered_address_post_code',
                    house_number : 'registered_address_building_no',
                    house_name : 'registered_address_building_name',
                    street_line_1 : 'registered_address_street',
                    city : 'registered_address_town_city',
                    country_code : 'registered_address_country_code',
                    county_code:'registered_address_county',

                }
                let data = {};

                Object.keys(dataMap).forEach(key => {
                    if (opportunity.hasOwnProperty(dataMap[key])){
                        data[key] = opportunity[dataMap[key]];
                    }
                })
                Object.keys(addressMap).forEach(key => {
                  if (opportunity.hasOwnProperty(addressMap[key])){
                    data[key]  = opportunity[addressMap[key]];
                  }
                })
                return data;
            },
            fetchApplicationData: function (application_reference = '') {
                //TODO query for application data so as to get application parameters.
                //TODO PLEASE review. I considered making a separate call for application parameters if
                //TODO user does not have application id in merchant_user_access
                //TODO but thought it would be too many calls taking place

                if (!this.isPublicUser && this.objectIsNotEmpty(this.merchant_user_access) && this.merchant_user_access.hasOwnProperty('application')) {

                    if (this.merchant_user_access.application.length > 1) {
                        //TODO if we have more than one quote, we need to know what to do
                        // FIXME Temp fix to make sure ui isn't broken
                        const application = this.merchant_user_access.application[this.merchant_user_access.application.length - 1];
                        application_reference = application.application_reference;
                    } else {
                        application_reference = this.merchant_user_access.application[0].application_reference;
                    }
                    let payload = {
                        application_reference: application_reference,
                    }
                    this[types.FETCH_APPLICATION_DATA](payload);
                }
            }
        },
        watch: {
            'tabsToRender': {
                immediate: true,
                handler: function (val, oldVal) {
                    if (!!val) {
                        this[types.COMMIT_APPLICATION_TABS](val);
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>